import React, { useState } from "react";

import {
  Box,
  Typography,
  Button,
  TextField,
  Paper,
  Snackbar,
  Alert,
} from "@mui/material";
import SideBar from "../../dashboard admin/components/SideBar"

import api from "../../../../services/api/api";

const CreateCategory = () => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // Função para lidar com o envio do formulário
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Obtenha o token do localStorage ou de onde estiver armazenado
    const token = localStorage.getItem("token");  // Ajuste conforme o local de armazenamento do token

    if (!token) {
      setSnackbarMessage("Token inválido ou não encontrado!");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return;
    }

    try {
      const response = await api.post(
        "api/categories",  // Ajuste a URL conforme a sua API
        { name, description },
        {
          headers: {
            Authorization: `Bearer ${token}`,  // Envia o token no cabeçalho
          },
        }
      );

      setSnackbarMessage("Categoria criada com sucesso!");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);

      // Limpa os campos do formulário
      setName("");
      setDescription("");
    } catch (error) {
      console.error("Erro ao criar categoria:", error);
      setSnackbarMessage("Erro ao criar categoria. Tente novamente.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#f5f5f5" }}>
      {/* Sidebar */}
      <Box>
        <SideBar />
      </Box>

      {/* Main Content */}
      <Box sx={{ flex: 1, p: 3 }}>
        <Typography variant="h4" fontWeight="bold" mb={3}>
          Criar Nova Categoria
        </Typography>

        <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3 }}>
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Nome da Categoria"
              variant="outlined"
              value={name}
              onChange={(e) => setName(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="Descrição"
              variant="outlined"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              sx={{ mb: 3 }}
            />
            <Button
              type="submit"
              variant="contained"
              sx={{
                background: "linear-gradient(90deg, #1cb5e0, #000851)",
                textTransform: "none",
              }}
            >
              Criar Categoria
            </Button>
          </form>
        </Paper>

        {/* Snackbar para mensagens de sucesso/erro */}
        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={() => setOpenSnackbar(false)}
        >
          <Alert
            onClose={() => setOpenSnackbar(false)}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
};

export default CreateCategory;
